import I18N from '@leverege/i18n'
import { DataViewerModel } from '@leverege/molten/data-viewers'

import EventsView from '../events/EventsView'
import EventsViewModel from '../events/EventsViewModel'

import StoreTrafficSupportDataViewer from './StoreTrafficSupportDataViewer'

const { tf, tfIcon } = I18N.ns( 'ps.dataViewers.StoreTrafficEventsDataViewer' )

export default {
  id : 'ps.dataViewers.StoreTrafficEventsDataViewer',
  type : 'ps.StoreTrafficEvents',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : [ 'main', 'card' ],
  matches : { type : [ 'ItemInfoDataViewer' ], objectType : 'store' },
  createSettings : ( props ) => {

    return EventsViewModel.create( {
      dataViewers : [ 
        DataViewerModel.create( 
          StoreTrafficSupportDataViewer.type, 
          StoreTrafficSupportDataViewer.createSettings( props ) )
      ],
      breakpoints : [ 'minWidth' ]
    } )
  },
  component : EventsView,
  getDefaultCardContentOptions : { height : '400px' }
}
